import styles from './NameInput.module.css'

export default function NameInput({name = "", setName = (value) => {}, label = "Имя", id = "name", placeholder = "Имя", auto_focus = false, error_message = "", reset_error_callback = () => {}})
{
    const inputHandler = (e) => {
        //Формируем callback для сохранения позиции каретки в случае, если данные не изменились несмотря на ввод пользователя
        const caretStart = e.target.selectionStart;
        const caretEnd = e.target.selectionEnd;
        const save_caret_callback = () => {e.target.setSelectionRange(caretStart, caretEnd)};

        //Проверяем полученные данные на длину и некорректные символы
        if(e.target.value.length > 20)
        {
            //Отрабатываем callback и выходим
            save_caret_callback();
            return;
        }
        for(let symbol of e.target.value)
            if((symbol < 'А' || symbol > 'я') && symbol != '-')
            {
                //Отрабатываем callback и выходим
                save_caret_callback();
                return;
            }

        //Сохраняем полученное значение, выставляя первую букву прописной (а также букву после дефиса), а остальные строчными
        let new_name = e.target.value.toLowerCase().replace(/(^|\-)[а-яё]/gi, (match) => match.toUpperCase());

        //Обновляем состояние
        setName(new_name);
        //Сбрасываем ошибку
        reset_error_callback();
    }

    return (
        <div className={styles.formGroup}>
            <input id={id} name={id} className={error_message.length ? [styles.formInput, styles.error].join(' ') : styles.formInput} type="text" placeholder={placeholder} value={ name } onChange={ inputHandler }></input>
            <label htmlFor={id} className={styles.formLabel}>{label}</label>
            <span className={styles.formClear} onClick={(e) => { setName(""); reset_error_callback(); }}>
                <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 10.0914L10 1.09137M1 1L10 9.99999" stroke="#7E7E7E" strokeWidth="0.909137" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </span>
            {error_message.length !== 0 &&
            <div className={styles.formError}>{error_message}</div>
            }
        </div>
    );
}
